export function loadGameState(state) {
  return {
    type: 'LOAD_GAME_STATE',
    payload: state,
  };
}

export function toggleSettingsPopup(isOpen) {
  return {
    type: 'TOGGLE_SETTINGS_POPUP',
    payload: isOpen,
  };
}

export function updateSettings(settings) {
  return {
    type: 'UPDATE_SETTINGS',
    payload: settings,
  };
}

export function setWindowPosition(payload) {
  return {
    type: 'SET_WINDOW_POSITION',
    payload: payload,
  };
}

export function setActiveWindow(windowID) {
  return {
    type: 'SET_ACTIVE_WINDOW',
    payload: windowID,
  };
}

export function updateWindows(windows) {
  return {
    type: 'UPDATE_WINDOWS',
    payload: windows,
  };
}

export function updateWindowStack(windowStack) {
  return {
    type: 'UPDATE_WINDOW_STACK',
    payload: windowStack,
  };
}
